import React, { useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official/dist/highcharts-react.min';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { Link } from "react-router-dom";
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const DailyTimeChart = () => {
    const categories = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const timeLabels = ['1:20', '1:40', '0:50', '1:50', '2:30', '1:30', '3:20'];
    const dataInMinutes = [80, 100, 50, 110, 150, 90, 200]; // for actual bar height

    const options = {
        chart: {
            type: 'column',
            height: 'auto',
        },
        title: { text: '' },
        xAxis: {
            lineWidth: 0, // 👈 Removes the black horizontal axis line
            tickLength: 0, // Optional: hides tick marks too
            categories,
            labels: {
                style: {
                    fontSize: '12px',
                    color: '#64748B',
                }
            }
        },
        yAxis: {
            visible: false, // hide y-axis
        },
        plotOptions: {
            column: {
                borderRadius: 100,
                borderRadiusBottom: 100,
                color: '#ff8800',
                pointWidth: 22, // Set exact bar width
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return timeLabels[this.point.index];
                    },
                    style: {
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#000',
                    }
                }
            }
        },
        tooltip: {
            enabled: true,
        },
        series: [{
            name: 'Work Duration',
            data: dataInMinutes,
            showInLegend: false,
            color: '#ff8800'
        }],
        credits: {
            enabled: false
        }
    };
    const [loading, setLoading] = useState(true);

    setTimeout(() => {
        setLoading(false)
    }, 2000)
    return (
        <>
            <div className='card-body p-20 bg-base border rounded-3 h-100'>
                <Box display="flex" justifyContent="space-between" className=" pb-16 mb-0 border-bottom">
                    <h6 className=" fw-semibold mb-0" style={{fontSize: '17px'}}>This Week  <Tooltip title="Daily Time" arrow placement="top">
                        <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                            <InfoOutlineIcon fontSize="small" />
                        </button>
                    </Tooltip></h6>
                    <Link to="/time-and-activity"
                        style={{ cursor: "pointer", fontSize: '14px', color: '#004DFF', }}
                    >
                        View report
                    </Link>
                </Box>

                {
                    loading ? (
                        <Box p={2} sx={{ position: 'relative' }}>
                            <Box display="flex" gap={2} alignItems="flex-end" height='340px'>
                                <Skeleton
                                    variant="rectangular"
                                    width={40}
                                    height={100}
                                    animation="wave"
                                    sx={{ borderRadius: '40px 40px 0 0' }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={40}
                                    height={300}
                                    animation="wave"
                                    sx={{ borderRadius: '40px 40px 0 0' }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={40}
                                    height={240}
                                    animation="wave"
                                    sx={{ borderRadius: '40px 40px 0 0' }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={40}
                                    height={140}
                                    animation="wave"
                                    sx={{ borderRadius: '40px 40px 0 0' }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={40}
                                    height={210}
                                    animation="wave"
                                    sx={{ borderRadius: '40px 40px 0 0' }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={40}
                                    height={120}
                                    animation="wave"
                                    sx={{ borderRadius: '40px 40px 0 0' }}
                                />
                                <Skeleton
                                    variant="rectangular"
                                    width={40}
                                    height={280}
                                    animation="wave"
                                    sx={{ borderRadius: '40px 40px 0 0' }}
                                />
                            </Box>
                            <Box display="flex" justifyContent="space-around" mt={1}>
                                <Skeleton variant="text" width={40} height={20} sx={{marginLeft: '5px'}} />
                                <Skeleton variant="text" width={40} height={20} sx={{marginLeft: '5px'}} />
                                <Skeleton variant="text" width={40} height={20} sx={{marginLeft: '5px'}} />
                                <Skeleton variant="text" width={40} height={20} sx={{marginLeft: '5px'}} />
                                <Skeleton variant="text" width={40} height={20} sx={{marginLeft: '5px'}} />
                                <Skeleton variant="text" width={40} height={20} sx={{marginLeft: '5px'}} />
                                <Skeleton variant="text" width={40} height={20} sx={{marginLeft: '5px'}} />
                            </Box>
                        </Box>
                    ) : (
                        <HighchartsReact highcharts={Highcharts} options={options} />
                    )
                }


            </div>
        </>
    );
};

export default DailyTimeChart;
